import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyBar() {
  // Start at 5:47 (347 seconds)
  const [timeLeft, setTimeLeft] = useState(347);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full bg-[#dc2626] text-white py-3 px-4 shadow-lg" data-id="element-392">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-393">
        <div className="flex items-center gap-2" data-id="element-394">
          <ClockIcon className="w-5 h-5 animate-pulse" data-id="element-395" />
          <span data-id="element-396">
            ATENCIÓN: La oferta de lanzamiento de 'Código Alfa 40+' con el 75%
            de descuento expira en:
          </span>
        </div>
        <div className="flex items-center gap-2 font-bold bg-black/20 px-3 py-1 rounded-md" data-id="element-397">
          <span className="text-xl tracking-wider" data-id="element-398">{formattedTime}</span>
          <span data-id="element-399">minutos.</span>
        </div>
        <span className="hidden md:inline" data-id="element-400">
          Cupos limitados para la comunidad VIP.
        </span>
      </div>
    </div>;
}